/* eslint-disable no-undef */
(function (window) {
    "use strict";

    function defineCustomerService() {
        let customerService = {};
        customerService.addCustomerLead = function (firstName, lastName, mobileNumber) {
            return axios.post("/api/Customer/AddCustomerLead", {
                firstName: firstName, lastName: lastName, mobileNumber: mobileNumber
            }).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        customerService.resendOtp = function (instanceId) {
            return axios.post("/api/Customer/ResendOtp", {
                instanceId: instanceId
            }).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        customerService.verifyOtp = function (otp, instanceId) {
            return axios.post("/api/Customer/VerifyOtp", {
                instanceId: instanceId, otp: otp
            });
        };
        customerService.addNewCustomer = function (request) {
            return axios.post("/api/Customer/AddNewCustomer", request)
                .then(response => {
                    return response;
                })
                .catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        return customerService;
    }

    //define globally if it doesn't already exist
    if (typeof (customerService) === "undefined") {
        window.customerService = defineCustomerService();
    } else {
        console.log("customerService already defined.");
    }
})(window);